<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <!-- <template v-slot:activator="{ on }">
      <v-btn v-if="!event.name" fab dark small color="primary" v-on="on">
        <span style="position:absolute; left:-140px ; color:#000">add appointment</span>
        <v-icon>mdi-calendar-plus</v-icon>
      </v-btn>
      <v-btn v-else icon fab v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>-->
    <v-card>
      <v-card-title>
        <span class="headline">{{ event.id ? "Edit" : "Add" }} event</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-menu
                v-model="menu_date"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="event.date"
                    label="Date"
                    prepend-icon="mdi-calendar-today"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.event.date.$touch()"
                    @blur="$v.event.date.$touch()"
                    :error-messages="eventDateErrors"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="event.date"
                  @input="menu_date = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-menu
                ref="time_menu"
                v-model="menu_time"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="event.startTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    dense
                    v-model="event.startTime"
                    label="Time"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    @input="$v.event.startTime.$touch()"
                    @blur="$v.event.startTime.$touch()"
                    :error-messages="eventStartErrors"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu_time"
                  v-model="event.startTime"
                  full-width
                  format="24hr"
                  :allowed-minutes="allowedMinutes"
                  :allowed-hours="allowedHours"
                  @click:minute="$refs.time_menu.save(event.startTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                outlined
                dense
                v-model="event.client"
                :items="clientItems"
                :loading="isLoading"
                :search-input.sync="search"
                clearable
                hide-selected
                item-text="fullData"
                item-value="id"
                return-object
                label="Client name..."
                ref="combobox"
                color="primary"
                @input="$v.event.client.$touch()"
                @blur="$v.event.client.$touch()"
                :error-messages="clientErrors"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>No clients</v-list-item-title>
                  </v-list-item>
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="item.fullData"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                outlined
                v-model="event.services"
                :items="services"
                label="Services"
                multiple
                chips
                small-chips
                return-object
                deletable-chips
                required
                color="primary"
                type="button"
                item-text="serviceName"
                item-value="id"
                @input="$v.event.services.$touch()"
                @blur="$v.event.services.$touch()"
                :error-messages="servicesErrors"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" v-if="isRepeaButtontVisible">
              <repeater-dialog
                :event="event"
                v-on:saveRepetitions="saveRepetitions"
              ></repeater-dialog>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                v-model="event.description"
                label="Description"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">Close</v-btn>
        <v-btn color="primary" :disabled="this.$v.$invalid" light @click="save">
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import repeaterDialog from "./RepeaterDialog";

export default {
  name: "AppointmentDialog",
  props: ["event"],
  components: {
    repeaterDialog
  },
  data: () => ({
    isVisible: false,
    menu_date: false,
    menu_time: false,
    end: null,
    clients: [],
    services: [],
    isLoading: false,
    search: null
  }),
  validations: {
    event: {
      services: { required },
      date: { required },
      // start: { required },
      startTime: { required },
      client: {
        id: { required }
      }
    }
  },
  methods: {
    saveRepetitions(repetitions) {
      this.event.repetitions = repetitions;
    },
    allowedHours(v) {
      return v >= this.$store.getters.startingHour;
    },
    allowedMinutes: v => v % 5 === 0,
    allowedStep: v => v % 5 === 0,
    getClients() {
      let querystring = `
            query clients2( $companyId: String!){
                clients2(companyId:$companyId, ){
                id,
                name,
                phoneNumber,
                description,
              }
            }
            `;
      this.isLoading = true;
      axios
        .post("/graphql", {
          query: querystring,
          variables: {
            companyId: this.$store.getters.user.details.companyId
          }
        })
        .then(res => {
          this.clients = res.data.data.clients2;
        })
        .catch(() => {
          this.showError("Could not get clients. Something went wrong");
        })
        .finally(() => (this.isLoading = false));
    },
    getServices() {
      var queryString = `query companyservices($companyID: String!){
                        companyservices(companyID:$companyID){
                            id
                            serviceName
                            duration
                            price
                        }
                    }`;
      axios
        .post("/graphql", {
          query: queryString,
          variables: { companyID: this.$store.getters.user.details.companyId }
        })
        .then(response => {
          if (response.data.data.companyservices) {
            this.services = response.data.data.companyservices;
          }
        })
        .catch(() => {
          this.showError("Could not get services");
        });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let appointmentServices = [];
      if (this.event.services.length > 0) {
        this.event.services.forEach(service => {
          appointmentServices.push({
            serviceID: service.id,
            appointmentID: this.event.id ?? null
          });
        });
      }

      let appointment = {
        
          id: this.event.id ?? null,
          clientID: this.event.client.id,
          type: "appointment",
          name: this.event.name ?? null,
          startTimeStamp: `${this.event.date} ${this.event.startTime}`,
          endTimeStamp: this.endtime,
          duration: this.duration,
          description: this.event.description,
          appointmentservice: appointmentServices,
          companyId: this.$store.getters.user.details.companyId,
          assignedTo: this.$store.getters.SelectedUser.id,
          createdByUserID: this.$store.getters.user.details.id,
          
        
      };
      let repetitions = this.event.repetitions != null && this.event.repetitions.length > 0 ? this.event.repetitions: null
      let mutation = ` mutation saveAppointment($appointment: SaveAppointment!, $repetitions: [DateTime]) {
                                saveAppointment(appointment: $appointment, repetitions: $repetitions) {
                                id
                                }
                            }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables:{appointment, repetitions}
        })
        .then(res => {
          if (res.data.data.saveAppointment) {
            this.closeDialog();
            this.showSuccess("Appointment saved!");
          }
        })
        .catch(() => this.showError("Error occured while saving appointment!"));
    },

    closeDialog() {
      this.$emit("close");
      this.isVisible = false;
    },
    openRepeatDialog() {}
  },
  computed: {
    isRepeaButtontVisible() {
      return (
        this.event.id == null &&
        this.event.client != null &&
        this.event.client.id !== "" &&
        this.event.services != null &&
        this.event.services.length > 0
      );
    },
    start: {
      get() {
        return this.event.start
          ? moment(this.event.start).format("HH:mm")
          : null;
      },
      set(val) {
        this.event.start = `${this.event.date} ${val}`;
      }
    },
    duration() {
      let duration = 0;
      if (this.event.services.length > 0) {
        this.event.services.forEach(service => {
          duration += service.duration;
        });
      }
      return duration;
    },
    endtime() {
      return moment(`${this.event.date} ${this.event.startTime}`)
        .clone()
        .add(this.duration, "s")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    clientItems() {
      return this.clients.map(client => {
        return Object.assign(client, {
          fullData: `${client.name} (${client.phoneNumber}) ${
            client.description == null || client.description == ''
              ? ''
              : client.description
          }`
        });
      });
    },
    eventDateErrors() {
      const errors = [];
      if (!this.$v.event.date.$dirty) return errors;
      !this.$v.event.date.required && errors.push("Date is required");
      return errors;
    },
    eventStartErrors() {
      const errors = [];
      if (!this.$v.event.startTime.$dirty) return errors;
      !this.$v.event.startTime.required && errors.push("Time is required");
      return errors;
    },
    clientErrors() {
      const errors = [];
      if (!this.$v.event.client.$dirty) return errors;
      !this.$v.event.client.id.required && errors.push("Client is required");
      return errors;
    },
    servicesErrors() {
      const errors = [];
      if (!this.$v.event.services.$dirty) return errors;
      !this.$v.event.services.required && errors.push("Services are required");
      return errors;
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.$v.$reset();
        this.getClients();
        this.getServices();
      }
    },
    search(val) {
      // Items have already been loaded
      if (this.clientItems.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;

      if (val) {
        // Lazily load input items
        let queryString = `query clients($clientName: String!, $companyId: String!){
        clients(clientName:$clientName,companyId:$companyId, ){
            id
            name
            description
            phoneNumber
            }
        }`;
        axios
          .post("/graphql", {
            query: queryString,
            variables: {
              clientName: val,
              companyId: this.$store.getters.user.details.companyId
            }
          })
          .then(res => {
            if (res.data.data.clients) {
              this.clients = res.data.data.clients;
            }
          })
          .catch(() => {
            this.showError("Error occured while searching for client!");
          })
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>

<style>
</style>